/**
 * Transition Design Tokens
 *
 * Durations and easing curves mirrored from MUI's transition system so the
 * Tailwind side stays in sync with components still rendered through MUI.
 *
 * MUI's easeIn / easeOut / easeInOut curves are byte-identical to Tailwind's
 * stock `ease-in` / `ease-out` / `ease-in-out`, so only `sharp` is added here —
 * use the stock utilities for the other three.
 */

export const transitionDurations = Object.freeze({
  shortest: '150ms',
  shorter: '200ms',
  short: '250ms',
  standard: '300ms',
  complex: '375ms',
  entering: '225ms', // MUI enteringScreen
  leaving: '195ms', // MUI leavingScreen
})

export const transitionEasings = Object.freeze({
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
})
